<template>
    <div class="wait" :style="height">

        <div>
            <h2>
                <span>ADVERTISING</span>
                <span>HAS BEEN LAUNCHED</span>
                <span>FOR <b>{{num}}</b> DAYS</span>
            </h2>
        </div>


      <vue-particles
        color="#ffffff"
        :particleOpacity="0.3"
        linesColor="#ffffff"
        :particlesNumber="80"
        shapeType="circle"
        :particleSize="5"
        :linesWidth="2"
        :lineLinked="true"
        :lineOpacity="0.2"
        :linesDistance="150"
        :moveSpeed="3"
        :hoverEffect="true"
        hoverMode="grab"
        :clickEffect="true"
        clickMode="push"
      >
      </vue-particles>
    </div>
</template>
<style >
    .wait{background: #004976;min-height: 730px;font-family: Teko,sans-serif;position: relative;}
    .wait h2{text-align: center;position: absolute;width: 100%;top:20%;}
    .wait h2 span{display: block;font-size: 85px;color: #007dbb;}
    .wait h2 span b{color: #fff}
</style>

<script>
    export default {
        name: 'fifth',
        data () {
            return {
                num:0,
                height:{
                    height:''
                }
            }
        },
        methods:{
         time(){
            var self = this;
            let i = 0
            var timer =  setInterval(function(){
            i++
            self.num=i
            if(i == 30){
                clearInterval(timer);
                self.$router.push('sixth')
            }
          },50)
          }
        },
        created(){
            this.time();
            this.height.height=window.innerHeight+'px'

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/fifth.vue